export class Employment {
    public id: string;
    public title: string;
    public employer: string;
    public startUnixTimestamp: number;
    public endUnixTimestamp: number;

    constructor() {

    }
}
